<script>
    import { Link } from "@inertiajs/vue3";

    export default {
        components: {
            Link,
        },
        methods: {
            scrollToSection(event, id) {
                event.preventDefault();
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            },
        },
    };
</script>

<template>
    <header class="bg-agent-ink">
        <div class="relative mx-auto max-w-6xl px-6">
            <div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-4 py-7 lg:flex lg:justify-between">
                <Link href="/">
                    <img src="/images/logo.png" alt="kiralabunu" class="h-8 w-auto" />
                </Link>

                <nav class="hidden items-center gap-7 lg:flex">
                    <Link href="/" class="text-sm text-agent-ink-foreground/80 transition-colors hover:text-agent-lime"> Ana Sayfa </Link>
                    <a href="#nasil-calisir" class="text-sm text-agent-ink-foreground/80 transition-colors hover:text-agent-lime" @click="scrollToSection($event, 'nasil-calisir')"> Nasıl Çalışır? </a>
                    <a href="#avantajlar" class="text-sm text-agent-ink-foreground/80 transition-colors hover:text-agent-lime" @click="scrollToSection($event, 'avantajlar')"> Avantajlar </a>
                    <Link href="/kurumsal" class="text-sm text-agent-ink-foreground/80 transition-colors hover:text-agent-lime"> Kurumsal </Link>
                    <a href="#basvuru" class="rounded-full border border-agent-lime px-6 py-2.5 text-sm font-medium text-agent-lime transition-colors hover:bg-agent-lime hover:text-agent-ink" @click="scrollToSection($event, 'basvuru')"> Hemen Başvur </a>
                </nav>

                <a href="#basvuru" class="rounded-full border border-agent-lime px-4 py-2 text-xs font-medium text-agent-lime transition-colors hover:bg-agent-lime hover:text-agent-ink lg:hidden" @click="scrollToSection($event, 'basvuru')"> Başvur </a>
            </div>

            <div class="flex overflow-x-auto pb-4 lg:hidden">
                <ul class="flex items-center gap-4 whitespace-nowrap px-1">
                    <li>
                        <Link href="/" class="text-xs font-santralregular font-semibold text-agent-ink-foreground/80 hover:text-agent-lime"> Ana Sayfa </Link>
                    </li>
                    <li>
                        <Link href="/kurumsal" class="text-xs font-santralregular font-semibold text-agent-ink-foreground/80 hover:text-agent-lime"> Kurumsal </Link>
                    </li>
                    <li>
                        <a href="#nasil-calisir" class="text-xs font-santralregular font-semibold text-agent-ink-foreground/80 hover:text-agent-lime" @click="scrollToSection($event, 'nasil-calisir')"> Nasıl Çalışır? </a>
                    </li>
                    <li>
                        <a href="#avantajlar" class="text-xs font-santralregular font-semibold text-agent-ink-foreground/80 hover:text-agent-lime" @click="scrollToSection($event, 'avantajlar')"> Avantajlar </a>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</template>
